/**
 * RS-3a — the palette a contractor is given: /p/{code}.
 *
 * The same pattern as /m/{code} — no login, no shell. The colours, their names
 * and their codes. Nothing else belongs on this page.
 */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '@/styles/palette-public.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const bare = axios.create();

export default function PalettePublicPage() {
  const { code } = useParams();
  const [palette, setPalette] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    bare.get(`${API}/p/${code}`)
      .then((r) => setPalette(r.data))
      .catch(() => setMissing(true));
  }, [code]);

  if (missing) {
    return (
      <div className="kpp" data-testid="palette-public">
        <div className="kpp-empty" data-testid="palette-public-missing">
          <b>No palette at this address.</b>
        </div>
      </div>
    );
  }
  if (!palette) return <div className="kpp" data-testid="palette-public-loading" />;

  return (
    <div className="kpp" data-testid="palette-public">
      <div className="kpp-head">
        <span className="kpp-eyebrow">Palette</span>
        <h1 className="kpp-title" data-testid="palette-public-name">{palette.name}</h1>
      </div>
      <div className="kpp-list">
        {(palette.colors || []).map((c, i) => (
          <div className="kpp-row" key={`${c.hex}-${i}`} data-testid={`palette-public-color-${i}`}>
            <span className="kpp-chip" style={{ backgroundColor: c.hex }} />
            <span className="kpp-words">
              <span className="kpp-name">{c.name || c.hex}</span>
              <span className="kpp-code">{c.code || c.hex}</span>
            </span>
          </div>
        ))}
        {(palette.colors || []).length === 0 && (
          <div className="kpp-empty" data-testid="palette-public-none">
            <b>No colours on this palette yet.</b>
          </div>
        )}
      </div>
    </div>
  );
}
